<template>
  <div class="notice_info" v-if="info">
    <div class="title">{{info.title}}</div>
    <div class="content">{{info.noticeContent}}</div>
    <p class="date">{{info.createTime}}</p>
  </div>
</template>
<script>
export default {
  data(){
    return {
      info: null,
    }
  },
  mounted(){
    this.info = this.$route.query;
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
  .notice_info{
    margin: 0 auto;
    padding: px2rem(120) px2rem(40);
    min-height: px2rem(900);
    background: #fff;
    .title{
      text-align: center;
      font-size: px2rem(36);
    }
    .content{
      font-size: px2rem(30);
      padding: px2rem(50) 0;
      text-indent: px2rem(30);
      line-height: px2rem(52);
    }
    .date{
      margin-top: px2rem(100);
      color: #7d7e80;
      font-size: px2rem(26);
      text-align: right;
    }
  }
</style>